import { render, staticRenderFns } from "./self-edit.vue?vue&type=template&id=094ad938&"
import script from "./self-edit.vue?vue&type=script&lang=js&"
export * from "./self-edit.vue?vue&type=script&lang=js&"
import style0 from "./self-edit.vue?vue&type=style&index=0&id=094ad938&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports